import pickBy from 'lodash/pickBy';

export const defaultLocale = 'en';
export const tempLocale = 'untranslatable_fallback';
export const acceptLocales = ['en', 'ru', 'de', 'ko', 'ja', 'zh', 'es', 'pt', 'fr'];

/**
 * Sanitize locale value
 * @param locale
 * @returns string
 */
export const sanitizeLocale = rawLocale => {
  const sanitizedLocale =
    rawLocale &&
    rawLocale
      .toString()
      .slice(0, 2)
      .toLocaleLowerCase();
  return acceptLocales.includes(sanitizedLocale) ? sanitizedLocale : defaultLocale;
};

/**
 * Import localization messages by pre-sanitized locale code
 * @param {string} sanitizedLocale
 * @returns {Object<string, string>}
 */
export const getTranslationsData = sanitizedLocale => ({
  ...require(`../translations/${tempLocale}.json`),
  ...require(`@xsolla/uikit/lib/_translations/${sanitizedLocale}.json`),
  ...require(`../translations/${defaultLocale}.json`),
  ...pickBy(require(`../translations/${sanitizedLocale}.json`))
});
